const KEYS = {
    APPOINTMENT_DATE: 'appointment_date',
    TIME: 'time',
    TYPE: 'type',
    PERSONS: 'persons',
    ADDONS: 'addons',
    PRICE: 'price',
    PRICE_DETAILS: 'hidden_price_details',
};

window.addEventListener('DOMContentLoaded', () => {
    class SummaryFormHandler {
        constructor() {
            this.fields = {};
            this.priceDetails = [];
            this.summaryVisible = false;
            Backbone.Radio.channel('fields').on('change:model', (fieldModel) => this.updateSummary(fieldModel,true));
            Backbone.Radio.channel('form').on('render:view', this.onFormRender.bind(this));

            // Create a MutationObserver to watch for changes in the DOM
            this.observer = new MutationObserver(this.checkSummaryVisibility.bind(this));
            this.observer.observe(document.body, { childList: true, subtree: true });
        }

        onFormRender() {
            // Update all summary fields when the form is rendered
            Object.values(KEYS).forEach(key => {
                const fieldModel = Backbone.Radio.channel('fields').request('get:field', key);
                if (fieldModel) {
                    this.updateSummary(fieldModel);
                }
            });
        }

        checkSummaryVisibility(mutations) {
            for (let mutation of mutations) {
                if (mutation.type === 'childList') {
                    const summaryElement = document.querySelector('[data-total-price-calculation]');
                    if (summaryElement && !this.summaryVisible) {
                        this.summaryVisible = true;
                        this.updateAllFields();
                        break;
                    } else if (!summaryElement) {
                        this.summaryVisible = false;
                    }
                }
            }
        }

        updateAllFields() {
            Object.values(this.fields).forEach(fieldModel => {
                this.updateSummary(fieldModel, true);
            });
        }

        updateSummary(fieldModel, forceUpdate = false) {
            const fieldKey = fieldModel.get('key');
            this.fields[fieldKey] = fieldModel;

            if (this.allRequiredFieldsPresent() && (forceUpdate || this.summaryVisible)) {
                if ([KEYS.TYPE, KEYS.PERSONS, KEYS.ADDONS, KEYS.APPOINTMENT_DATE].includes(fieldKey) || forceUpdate) {
                    const newPrice = this.calculatePrice();
                    if (this.fields[KEYS.PRICE]) {
                        this.fields[KEYS.PRICE].set('value', this.formatPrice(newPrice));
                        this.fields[KEYS.PRICE].trigger('reRender', this.fields[KEYS.PRICE]);
                    }
                    this.updatePriceDetails();
                }
            }
        }

        allRequiredFieldsPresent() {
            return [KEYS.PERSONS, KEYS.TYPE, KEYS.ADDONS, KEYS.APPOINTMENT_DATE].every(key => this.fields[key]);
        }

        calculatePrice() {
            const persons = parseFloat(this.fields[KEYS.PERSONS].get('value')) || 0;
            const appointmentDate = this.fields[KEYS.APPOINTMENT_DATE].get('value');

            this.priceDetails = [];
            let totalPrice = 0;

            const typePrice = this.calculateTypePrice(persons, appointmentDate);
            totalPrice += typePrice;

            const addonPrice = this.calculateAddonPrice(persons);
            totalPrice += addonPrice;

            return totalPrice;
        }

        calculateTypePrice(persons, appointmentDate) {
            const typeValue = this.fields[KEYS.TYPE].get('value');
            if (!typeValue) return 0;

            const typeContainer = document.getElementById(`nf-field-${this.fields[KEYS.TYPE].get('id')}-container`);
            if (!typeContainer) {
                console.warn(`Type container not found for field ID: ${this.fields[KEYS.TYPE].get('id')}`);
                return 0;
            }

            const prices = typeContainer.querySelectorAll(`input[value="${typeValue}"] + label .c-listimage-card__content-price`);

            let totalTypePrice = 0;

            Array.from(prices).forEach(price => {
                const priceElement = price.querySelector('.c-listimage-card__content-value');
                if (!priceElement) return;

                const priceValue = parseFloat(priceElement.innerText.replace(/[^\d.]/g, '')) || 0;
                const priceText = price.innerText.toLowerCase();

                if (priceText.includes('kostenlos') || priceText.includes('zeitraum')) {
                    return;
                }

                if (priceText.includes('begleitperson') && persons > 4) {
                    const extraPersons = persons - 4;
                    const extraPersonPrice = extraPersons * priceValue;
                    totalTypePrice += extraPersonPrice;
                    this.priceDetails.push(`${extraPersons} Zusätzliche Begleitperson(en): ${this.formatPrice(extraPersonPrice)} €`);
                } else if (priceText.includes('samstag') && this.isSaturday(appointmentDate)) {
                    totalTypePrice += priceValue;
                    this.priceDetails.push(`Termin Gebühr: ${this.formatPrice(priceValue)} € (wird bei Kauf wiedererstattet)`);
                } else if (priceText.includes('montag') && !this.isSaturday(appointmentDate)) {
                    totalTypePrice += priceValue;
                    this.priceDetails.push(`Termin Gebühr: ${this.formatPrice(priceValue)} € (wird bei Kauf wiedererstattet)`);
                } else if (!priceText.includes('begleitperson') && !priceText.includes('samstag') && !priceText.includes('montag')) {
                    totalTypePrice += priceValue;
                    this.priceDetails.push(`Grundpreis: ${this.formatPrice(priceValue)} €`);
                }
            });


            return totalTypePrice;
        }

        calculateAddonPrice(persons) {
            const addonContainer = document.getElementById(`nf-field-${this.fields[KEYS.ADDONS].get('id')}-container`);
            if (!addonContainer) {
                console.warn(`Addon container not found for field ID: ${this.fields[KEYS.ADDONS].get('id')}`);
                return 0;
            }

            if(!Array.isArray(this.fields[KEYS.ADDONS].get('value'))) {
                console.warn(`No array values: ${this.fields[KEYS.ADDONS].get('id')}`);
                return 0;
            }

            return this.fields[KEYS.ADDONS].get('value').reduce((sum, value) => {
                const priceElement = addonContainer.querySelector(`input[value="${value}"] + label .c-listimage-card__content-price`);
                if (!priceElement) return sum;

                const isPerPerson = priceElement.innerText.toLowerCase().includes('person');
                const priceValueElement = priceElement.querySelector('.c-listimage-card__content-value');
                const priceValue = priceValueElement ? parseFloat(priceValueElement.innerText.replace(/[^\d.]/g, '')) : 0;
                const totalAddonPrice = isPerPerson ? (persons + 1) * priceValue : priceValue; //plus to include booking person herself

                const addonName = addonContainer.querySelector(`input[value="${value}"] + label .c-listimage-card__content-title`).innerText;
                this.priceDetails.push(`${addonName}: ${this.formatPrice(totalAddonPrice)} €`);

                return sum + totalAddonPrice;
            }, 0);
        }

        isSaturday(dateString) {
            if(dateString === 0) return false;
            const date = new Date(dateString.split('.').reverse().join('-'));
            return date.getDay() === 6; // 6 represents Saturday (0 is Sunday, 1 is Monday, etc.)
        }

        updatePriceDetails() {
            const detailsContainer = document.querySelector('[data-total-price-calculation]');
            if (detailsContainer) {
                const ul = document.createElement('ul');
                this.priceDetails.forEach(detail => {
                    const li = document.createElement('li');
                    li.textContent = detail;
                    ul.appendChild(li);
                });
                detailsContainer.innerHTML = '';
                detailsContainer.appendChild(ul);
            }

            if (this.fields[KEYS.PRICE_DETAILS]) {
                this.fields[KEYS.PRICE_DETAILS].set('value', this.priceDetails.join('\n'));
                this.fields[KEYS.PRICE_DETAILS].trigger('reRender', this.fields[KEYS.PRICE_DETAILS]);
            }
        }

        formatPrice(price) {
            return Number.isInteger(price) ? price.toString() : price.toFixed(2);
        }
    }

    jQuery(document).ready(() => new SummaryFormHandler());
}, { once: true });

function findObjectModel(objs, key) {
    return objs.find(obj => obj.get('key') === key);
}